const AdminModule = () => import("../views/admin-module.vue");
const VehicleCheckCfg = () => import("../views/vehicle-check-cfg.vue");
const VehicleThreeCheckCfg = () => import("../views/vehicle-three-check-cfg.vue");
const VehicleThreeCheckLog = () => import("../views/vehicle-three-check-log.vue");
const VehicleCheckLog = () => import("../views/vehicle-check-log.vue");
import { CrudRouter, SimpleUploader } from "javaee-fre";
const routers = [
    {
        path: 'home/admin/sys/module', component: CrudRouter, meta: {
            listItemActions: [{
                label: '开通企业', icon: 'group', func(cfg) {
                    this.$router.push(`/console/home/admin/sys/module/org/${cfg.item.id}`, `开通企业 - ${cfg.item.name}`);
                }
            }]
        },
        children: [
            { path: 'org/:_mid', component: CrudRouter, meta: { name: '开通企业' } }
        ]
    },
    { path: 'home/admin/m/sys/vehicle/check/tmpl', component: CrudRouter },
    {
        path: 'home/admin/m/sys/vehicle/check/opt', component: CrudRouter, meta: {
            listItemActions: [{
                label: '检查项', icon: 'list', func(cfg) {
                    this.$router.push(`/console/home/admin/m/sys/vehicle/check/opt/items/${cfg.item.id}`, `检查项 - ${cfg.item.name}`);
                }
            }]
        }, children: [{
            path: 'items/:_gid', component: CrudRouter, meta: { name: '检查项', url: '/home/admin/m/sys/vehicle/check/opt' }
        }]
    },
    { path: 'home/admin/my/module', component: AdminModule, meta: { name: '应用超市' } },
    {
        path: 'home/admin/m/my/tenant/vehicle/mgr', component: CrudRouter, meta: {
            name: '车辆管理',
            listActions: [{
                label: '导入', func() {
                    let self = this;
                    self.$dialog.component('导入车辆', SimpleUploader, {
                        width: 600,
                        persist: true,
                        url: '/home/admin/m/my/tenant/vehicle/mgr/import',
                        templateUrl: '/s/a/vehicle_import.xlsx',
                        onUploadComplete(r) {
                            if (r.data && r.data.status == 'ok') {
                                self.$dialog.close();
                                self.$status('导入成功！', 'success');
                                self.refresh();
                            } else {
                                let err = r.data ? r.data.message : '导入出现错误';
                                self.$status(err, 'error');
                            }
                        }
                    });
                }
            }]
        }
    },
    {
        path: 'home/admin/m/my/tenant/vehicle/check/cfg', component: CrudRouter, meta: {
            name: '自定义检查要求', url: '/home/admin/m/my/tenant/vehicle/check/cfg',
            desc: '<p class="sys-info">可以点击右上角<b>新建</b>创建自定义检查要求。</p>',
            detailable: false,
            listItemActions: [{
                label: '设置检查项', icon: 'list', func(cfg) {
                    this.$router.push(`/console/home/admin/m/my/tenant/vehicle/check/cfg/opt/${cfg.item.id}`, `设置检查项 - ${cfg.item.name}`);
                }
            }, {
                label: '检查记录', icon: 'timeline', func(cfg) {
                    this.$router.push(`/console/home/admin/m/my/tenant/vehicle/check/cfg/log/${cfg.item.id}`, `检查记录 - ${cfg.item.name}`);
                }
            }]
        },
        children: [
            {
                path: 'log/:_cfgId', component: CrudRouter, meta: {
                    name: '检查记录',
                    url: '/home/admin/m/my/tenant/vehicle/check/log',
                    detailable: false,
                    listItemFilter(i, acts) {
                        let self = this;
                        self.delAction(acts, "__tag", 'edit');
                        if (self.$dictVal(i.status) != 1) {
                            self.delAction(acts, 'icon', 'done');
                        }
                        if (i.notPassOpt > 0) {
                            i._rowClazz = 'row-warning';
                        }
                        return acts;
                    },
                    listActions: [{
                        label: '导出详情', func() {
                            let self = this, sd = self.searchData()
                            if (!self.searching || !sd || !sd.month) {
                                self.$status('选择月份搜索才能导出详情～')
                                return
                            }
                            sd = { _cfgId: self.$route.params._cfgId, ...sd }
                            window.open(`${self.$const.baseUrl}/home/admin/m/my/tenant/vehicle/check/log/report/details.html?${self.$qs.stringify(sd)}`, '_blank');
                        }
                    }, {
                        label: '导出报表', func() {
                            let self = this, sd = self.searchData()
                            if (!self.searching || !sd || !sd.month) {
                                self.$status('选择月份搜索才能导出报表～')
                                return
                            }
                            sd = { _cfgId: self.$route.params._cfgId, ...sd }
                            window.open(`${self.$const.baseUrl}/home/admin/m/my/tenant/vehicle/check/log/report/summaries.html?${self.$qs.stringify(sd)}`, '_blank');
                        }
                    }],
                    listItemActions: [{
                        label: '查看详细记录', icon: 'ballot', func(cfg) {
                            this.$dialog.component('详细记录预览', VehicleCheckLog, { _lid: cfg.item.id });
                        }
                    }, {
                        label: '审查', icon: 'done', func(cfg) {
                            this.$parent.onEdit(cfg.item.id);
                        }
                    }, {
                        label: '打印记录', icon: 'print', func(cfg) {
                            let self = this;
                            window.open(`${self.$const.baseUrl}/home/admin/m/my/tenant/vehicle/check/log/report/detail/${cfg.item.id}.html`);
                        }
                    }]
                },
                children: [
                    {
                        path: 'detail/:_lid', component: VehicleCheckLog, meta: { name: '详细记录' }
                    }
                ]
            },
            { path: 'opt/:_cfgId', component: VehicleCheckCfg, meta: { name: '设置检查项' } }
        ]
    }, {
        path: 'home/admin/m/my/tenant/vehicle/three/check/log', component: CrudRouter, meta: {
            detailable: false,
            listActions: [{
                label: '三检要求设置', func() {
                    this.$router.push('/console/home/admin/m/my/tenant/vehicle/three/check/log/cfg');
                }
            }, {
                label: '导出详情', func() {
                    let self = this, sd = self.searchData()
                    if (!self.searching || !sd || !sd.month) {
                        self.$status('选择月份搜索才能导出详情～')
                        return
                    }
                    window.open(`${self.$const.baseUrl}/home/admin/m/my/tenant/vehicle/three/check/log/report/details.html?${self.$qs.stringify(sd)}`, '_blank');
                }
            }, {
                label: '导出报表', func() {
                    let self = this, sd = self.searchData()
                    if (!self.searching || !sd || !sd.month) {
                        self.$status('选择月份搜索才能导出报表～')
                        return
                    }
                    window.open(`${self.$const.baseUrl}/home/admin/m/my/tenant/vehicle/three/check/log/report/summaries.html?${self.$qs.stringify(sd)}`, '_blank');
                }
            }],
            onIniting() {
                let self = this;
                self.$axios.get('/home/admin/m/my/tenant/vehicle/check/cfg/check/three/cfgs').then(r => {
                    if (r.data.message < 3) {
                        self.desc('<p class="sys-info">在使用车辆三检前，请先点击<b>三检要求设置</b>按钮设置出车前、中、后的需要检查的项目。</p>');
                    }
                });
            },
            listItemActions: [{
                label: '查看详细记录', icon: 'ballot', func(cfg) {
                    this.$router.push(`/console/home/admin/m/my/tenant/vehicle/three/check/log/detail/${cfg.item.id}`, `详细记录 - ${cfg.item.checkerName}`);
                }
            }, {
                label: '审查', icon: 'done', func(cfg) {
                    this.$parent.onEdit(cfg.item.id, cfg.item.checkerName);
                }
            }, {
                label: '打印记录', icon: 'print', func(cfg) {
                    let self = this;
                    window.open(`${self.$const.baseUrl}/home/admin/m/my/tenant/vehicle/three/check/log/report/detail/${cfg.item.id}.html`);
                }
            }],
            listItemFilter(i, acts) {
                let self = this;
                self.delAction(acts, "__tag", 'edit');
                if (self.$dictVal(i.status) != 1) {
                    self.delAction(acts, 'icon', 'done');
                }
                if (i.notPassOpt > 0) {
                    i._rowClazz = 'row-warning';
                }
                return acts;
            }
        },
        children: [
            { path: 'detail/:_id', component: VehicleThreeCheckLog, meta: { name: '详细记录' } },
            { path: 'cfg', component: VehicleThreeCheckCfg, meta: { name: '三检要求设置' } }
        ]
    },
    {
        path: 'home/admin/m/my/tenant/promise/mgr', component: CrudRouter, meta: {
            richTextEditorCfg: {
                language_url: `${process.env.BASE_URL}tinyLanguage/zh_CN.js`,
                language: "zh_CN",
                skin_url: `${process.env.BASE_URL}skins/ui/oxide`,
                height: 400,
                plugins: ["lists"],
                toolbar:
                    "undo redo | formatselect | bold italic forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat",
                branding: true,
                menubar: false,
                content_css: `${process.env.BASE_URL}skins/content/default/content.min.css`,
                convert_urls: false,
                relative_urls: false
            },
            listItemActions: [
                {
                    label: '刷新承诺人数统计', icon: 'refresh', func(cfg) {
                        let self = this;
                        self.$axios.get(`/home/admin/m/my/tenant/promise/mgr/refresh/signed/${cfg.item.id}`).then(() => {
                            self.refresh();
                        });
                    }
                },
                {
                    label: '发布', icon: 'check', func(cfg) {
                        let self = this;
                        self.$axios.get(`/home/admin/m/my/tenant/promise/mgr/closed/${cfg.item.id}/${!cfg.item.closed}`).then(() => {
                            self.refresh();
                        });
                    }
                }, {
                    label: '已提交承诺书', icon: 'reorder', func(cfg) {
                        this.$router.push(`/console/home/admin/m/my/tenant/promise/mgr/log/${cfg.item.id}`);
                    }
                }
            ],
            listItemFilter(i, acts) {
                if (!i.closed) {
                    let act = this.getAction(acts, 'icon', 'check');
                    act.label = '关闭';
                    act.icon = 'block';
                }
                return acts;
            }
        },
        children: [
            {
                path: 'log/:_promise', component: CrudRouter, meta: {
                    name: '已提交承诺书', url: '/home/admin/m/my/tenant/promise/log/mgr',
                    listItemActions: [{
                        label: '导出', icon: 'save_alt', func(cfg) {
                            let self = this
                            window.open(`${self.$const.baseUrl}/home/admin/m/my/tenant/promise/log/mgr/pdf/${cfg.item.id}.pdf?_promise=${self.$route.params._promise}`, '_blank');
                        }
                    }]
                }
            }
        ]
    }
];
export default {
    routers: routers
}